/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { Text } from '@/shared/ui';
import {
  LEASE_STATE_STYLES,
  useLeaseStateLabel,
  type LeaseState,
} from '../constants/lease-states';

export interface LeaseStateBadgeProps {
  state: string;
}

/**
 * Colored badge for a lease's state in the registry vocabulary.
 *
 * @param props.state - The lease state value.
 * @returns The rendered badge.
 */
export function LeaseStateBadge({ state }: LeaseStateBadgeProps) {
  const label = useLeaseStateLabel();
  const style = LEASE_STATE_STYLES[state as LeaseState] ?? LEASE_STATE_STYLES.draft;

  return (
    <Text
      component="span"
      data-testid="lease-state-badge"
      className="inline-flex items-center px-(--space-2) py-(--space-0-5) rounded-full text-xs font-semibold whitespace-nowrap"
      style={{ background: style.bg, color: style.color }}
    >
      {label(state)}
    </Text>
  );
}

export default LeaseStateBadge;
